module.exports = __webpack_public_path__ + "img/tarjeta.8fc17325.jpg";